import PhoneNumber from './phone.number';

export default PhoneNumber;
